module.exports = __webpack_public_path__ + "img/dp3.ee10485c.jpg";